import React, { useEffect, useState } from "react";
import FlipCardSlider from "../components/Slider/FlipCardSlider";
import ArticleContainer from "../components/Article/ArticleContainer";
import ArticleHero from "../components/Hero/ArticleHero";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";

const Article = () => {
  const [article, setArticle] = useState({});
  const [relatedArticles, setRelatedArticles] = useState([]);
  const { slug } = useParams();
  const navigate = useNavigate();

  const getRelatedArticles = async (id) => {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/articles/${id}/related`
      );
      if (res.status === 200) {
        setRelatedArticles(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchArticle = async () => {
    // Fetch article data from API here
    console.log("Slug: " + slug);
    console.log(
      "API URL:",
      `${import.meta.env.VITE_API_BASE_URL}/api/articles/slug/${slug}`
    );

    try {
      const res = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/articles/slug/${slug}`
      );
      if (res.status === 200) {
        setArticle(res?.data);
        getRelatedArticles(res?.data?._id);
      }
    } catch (error) {
      console.log(error);
      navigate("/404");
    }
  };

  useEffect(() => {
    fetchArticle();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [slug]);

  return (
    <>
      <ArticleHero
        contentType={article?.contentType}
        title={article?.title}
        createdOn={moment(article?.createdAt).format("Do MMM, YYYY")}
        imgsrc="/images/about/bg8.webp"
      />
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Insights</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">{article?.contentType || "Article"}</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {article?.short}
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <ArticleContainer data={article} />
      {relatedArticles?.length > 0 && (
        <>
          <hr
            className="border-3"
            style={{ borderColor: "var(--accent-color)" }}
          />
          <div
            className="stories-section section my-5"
            style={{ maxWidth: "100%" }}
          >
            <div className="container">
              <FlipCardSlider
                data={relatedArticles}
                title={"You may also like"}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Article;
